import React from 'react';
import { HintTextTW } from 'tailwindComponents/formCellTW/HintTextTW';
import { DateFormat, getDateString } from 'ui-toolkit/utilities/getDateString';

export interface IDepositTooltipContentProps {
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

const stringCreation = (action: string, dateDisplay: string, by?: string) => {
  const result = [action, 'at', dateDisplay];

  if (by) {
    result.push('by', by);
  }

  return result.join(' ');
};

export const DepositTooltipContent: React.FC<IDepositTooltipContentProps> = ({
  createdAt,
  createdBy,
  updatedAt,
  updatedBy,
}) => {
  const createdAtDisplay = getDateString(DateFormat.hugeDateTime, `${createdAt}Z`);
  const updatedAtDisplay = getDateString(DateFormat.hugeDateTime, `${updatedAt}Z`);
  return (
    <>
      {!createdAt && <HintTextTW hintText={'This item has not been saved yet'} />}
      {createdAt && <HintTextTW hintText={stringCreation('Created', createdAtDisplay, createdBy)} />}
      {updatedAt && <HintTextTW hintText={stringCreation('Updated', updatedAtDisplay, updatedBy)} />}
    </>
  );
};
